import { useRestorePresentationMutation } from '@carboncopyco/data';
import { RevertOutlineIcon, ShowOutlineIcon } from '@carboncopyco/icons';
import type { EnhancedPresentation } from '@carboncopyco/types';
import { Button, ColorHex, TooltipBubble, notify } from '@carboncopyco/ui';
import { AnalyticsTrackEventName, useAnalytics } from '@carboncopyco/utils';
import { usePresentationPreview } from '../../usePresentationPreview';
import { useOverlayPageProps } from '../OverlayPageContext';

interface ArchivedRowButtonsProps {
  presentation: EnhancedPresentation;
}

export const ArchivedRowButtons = ({
  presentation,
}: ArchivedRowButtonsProps) => {
  const { trackEvent } = useAnalytics();
  const { organizationId, goToDemoPreview } = useOverlayPageProps();
  const [restorePresentation] = useRestorePresentationMutation();
  const handlePreview = usePresentationPreview({
    presentation,
    organizationId,
    goToDemoPreview,
    from: 'archive',
  });

  return (
    <div className="flex items-center gap-3">
      <TooltipBubble
        placement="top"
        title="Preview"
      >
        <Button
          aria-label="preview"
          dark
          icon={<ShowOutlineIcon color={ColorHex.natural600} />}
          onClick={() => {
            trackEvent(
              AnalyticsTrackEventName.DEMO_CLICK_PREVIEW_PRESENTATION,
              {
                location:
                  'demo_info_page_presentations_tab_archive_tab_table_side_actions',
              }
            );
            handlePreview();
          }}
        />
      </TooltipBubble>
      <TooltipBubble
        placement="top"
        title="Restore"
      >
        <Button
          aria-label="restore"
          dark
          icon={<RevertOutlineIcon color={ColorHex.natural600} />}
          onClick={() => {
            trackEvent(
              AnalyticsTrackEventName.DEMO_CLICK_RESTORE_PRESENTATION,
              {
                location:
                  'demo_info_page_presentations_tab_archive_tab_table_side_actions',
              }
            );
            restorePresentation({
              organizationId,
              id: String(presentation.id),
            })
              .unwrap()
              .then(() =>
                notify.success('Presentation was successfully restored')
              )
              .catch(() => notify.error('Error restoring presentation'));
          }}
        />
      </TooltipBubble>
    </div>
  );
};
